var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isNewEdition
    ? _c(
        "div",
        [
          _c("div", { staticClass: "select" }, [
            _c(
              "div",
              { staticStyle: { flex: "1" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "daterange",
                    "range-separator": "至",
                    "start-placeholder": "选择时间",
                    "end-placeholder": "选择时间",
                    "value-format": "yyyy-MM-dd",
                    size: "mini"
                  },
                  on: { change: _vm.handleDate },
                  model: {
                    value: _vm.date1,
                    callback: function($$v) {
                      _vm.date1 = $$v
                    },
                    expression: "date1"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "padding-right": "20px" } },
              [
                _c(
                  "el-button",
                  { attrs: { size: "mini" }, on: { click: _vm.handleOpen } },
                  [_vm._v("行为配置")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "ctx" }, [
                _vm._m(0),
                _c("div", { staticClass: "center" }, [
                  _c("div", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.chartSum1))
                  ]),
                  _c("div", [_vm._v("敏感行为数")])
                ]),
                _c(
                  "div",
                  { staticClass: "right", on: { click: _vm.getEmployeeList } },
                  [
                    _vm._v(" 查看明细"),
                    _c("i", { staticClass: "el-icon-arrow-right" })
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "ctx" }, [
                _vm._m(1),
                _c("div", { staticClass: "center" }, [
                  _c("div", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.chartSum2))
                  ]),
                  _c("div", [_vm._v("敏感行为员工数")])
                ])
              ])
            ])
          ]),
          _vm._m(2),
          _vm.dialogVisible
            ? _c(
                "el-dialog",
                {
                  attrs: {
                    title: "敏感行为设置",
                    visible: _vm.dialogVisible,
                    width: "32%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "background-color": "#f2f2f2" } },
                    [
                      _vm._v(
                        " 选择下列行为中的一些，定义为敏感行为，统计结果跟随设置改变，群聊行为需要开通席位才能进行统计。选择行为后，勾选提醒的条目会在触发时发送消息提醒。 "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "15px" } },
                    [
                      _c(
                        "el-scrollbar",
                        { staticStyle: { height: "250px" } },
                        [
                          _vm._l(_vm.list, function(item) {
                            return [
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    "margin-bottom": "20px",
                                    overflow: "hidden"
                                  },
                                  attrs: { span: 6 }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: item.isCheck,
                                        callback: function($$v) {
                                          _vm.$set(item, "isCheck", $$v)
                                        },
                                        expression: "item.isCheck"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.msgTypeName))]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "margin-bottom": "20px" },
                                  attrs: { span: 6 }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "tips",
                                      attrs: { disabled: !item.isCheck },
                                      model: {
                                        value: item.isRemind,
                                        callback: function($$v) {
                                          _vm.$set(item, "isRemind", $$v)
                                        },
                                        expression: "item.isRemind"
                                      }
                                    },
                                    [_vm._v("提醒")]
                                  )
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("div", [
                    _c("div", { staticStyle: { margin: "10px 0" } }, [
                      _vm._v("消息推送范围：")
                    ]),
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-plus", size: "mini" },
                            on: { click: _vm.handleSelect }
                          },
                          [_vm._v("选择推送人")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _vm._v(" 已选:"),
                        _vm._l(_vm.searchMenNames, function(tag, index) {
                          return _c(
                            "el-tag",
                            {
                              key: tag.userId,
                              staticStyle: { margin: "0 0 7px 7px" },
                              attrs: { closable: "", size: "mini" },
                              on: {
                                close: function($event) {
                                  return _vm.handleRemove(index)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(tag.userName) + " ")]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSave }
                        },
                        [_vm._v("设置完成")]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _c("StaffTree", {
            ref: "tree",
            attrs: {
              title: "选择成员",
              dialogVisibleTree: _vm.dialogVisibleTree,
              currentSelectMember: _vm.currentSelectMember
            },
            on: {
              closeTree: _vm.closeTree,
              clickSubmitTree: _vm.clickSubmitTree
            }
          }),
          _vm.dialogTableVisible
            ? _c(
                "el-dialog",
                {
                  staticStyle: { height: "1500px" },
                  attrs: {
                    title: "敏感行为明细表",
                    visible: _vm.dialogTableVisible
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogTableVisible = $event
                    },
                    close: function($event) {
                      _vm.dialogTableVisible = false
                    }
                  }
                },
                [
                  _vm._v(" 行为筛选："),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        size: "mini",
                        multiple: "",
                        "collapse-tags": ""
                      },
                      on: {
                        change: _vm.getEmployeeList,
                        clear: _vm.getEmployeeList
                      },
                      model: {
                        value: _vm.msgTypeList1,
                        callback: function($$v) {
                          _vm.msgTypeList1 = $$v
                        },
                        expression: "msgTypeList1"
                      }
                    },
                    _vm._l(_vm.list, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.msgTypeName,
                          value: item.msgTypeName
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" 职工筛选： "),
                  _c("el-select", {
                    attrs: {
                      multiline: "",
                      filterable: "",
                      remote: "",
                      clearable: "",
                      size: "mini"
                    },
                    on: {
                      focus: _vm.clickAddMember,
                      clear: function($event) {
                        return _vm.getEmployeeList(1)
                      }
                    },
                    model: {
                      value: _vm.employeeList1,
                      callback: function($$v) {
                        _vm.employeeList1 = $$v
                      },
                      expression: "employeeList1"
                    }
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "选择时间",
                      "end-placeholder": "选择时间",
                      size: "mini",
                      "value-format": "yyyy-MM-dd"
                    },
                    on: { change: _vm.getEmployeeList },
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  }),
                  _c(
                    "el-table",
                    {
                      staticStyle: { height: "500px" },
                      attrs: { data: _vm.tableData }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          property: "date",
                          label: "敏感行为",
                          width: "150",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "name",
                          label: "触发人",
                          width: "200",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "address",
                          label: "触发时间",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "address",
                          label: "聊天对象",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "padding-top": "10px"
                      }
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "page-sizes": [20, 50, 100, 200],
                          "page-size": _vm.pageSize,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.total
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("i", { staticClass: "el-icon-document" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("i", { staticClass: "el-icon-user" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { display: "flex" } }, [
      _c("div", {
        staticStyle: {
          height: "650px",
          width: "100%",
          "border-right": "1px solid #ddd"
        },
        attrs: { id: "left2" }
      }),
      _c("div", {
        staticStyle: { height: "650px", width: "100%" },
        attrs: { id: "left1" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }